import { PromoteDemoteOptions } from '../types'

/**
 * Helper function to calculate promotion and demotion eligibility
 *
 * @param options - The options containing content state and context
 * @returns Object containing canBePromoted and canBeDemoted flags
 */
export const validateEligibility = (options: PromoteDemoteOptions) => {
    const {
        isArticle,
        contentItemToPromoteDemote,
        isL1Paragraph,
        isInProject,
        isUserAdded,
        isContentTeamFromStudioPage,
        paragraphLevel,
        depth,
    } = options

    const hasSelectedContentItemToPromoteDemote = Boolean(
        contentItemToPromoteDemote
    )

    // Calculate promotion eligibility
    // Content cannot be promoted if:
    // 1. It's an L1 paragraph or article
    // 2. It's not from content team AND not in project
    const canBePromoted =
        hasSelectedContentItemToPromoteDemote &&
        !(
            isL1Paragraph ||
            isArticle ||
            (!isContentTeamFromStudioPage && (!isInProject || !isUserAdded))
        )

    let canBeDemoted = false

    // Special case for L1 paragraphs
    if (
        isL1Paragraph &&
        paragraphLevel > 0 &&
        (isContentTeamFromStudioPage ||
            (!isContentTeamFromStudioPage && isInProject && isUserAdded))
    ) {
        canBeDemoted = true
    }
    // Regular case - content can be demoted if:
    // 1. Not an L1 paragraph, not an article, and depth > 0 and < 6
    // 2. From content team OR in project
    else if (
        !isL1Paragraph &&
        !isArticle &&
        paragraphLevel > 0 &&
        (isContentTeamFromStudioPage ||
            (!isContentTeamFromStudioPage && isInProject && isUserAdded))
    ) {
        canBeDemoted = depth < 5
    }

    return {
        canBePromoted,
        canBeDemoted: hasSelectedContentItemToPromoteDemote && canBeDemoted,
    }
}
